<template>
  
  <tr>
    <td>{{ ChannelRegistry.find(channelFacility.channel)?.titleShort ?? channelFacility.channel }}</td>
    <td v-if="canSeeIds">
      <template v-if="canViewDashboard">
        <external-link :href="DashboardRouter.get('channelFacilityDetail', {channel_facility_id: channelFacility.ID})">
          {{ channelFacility.ID }}
        </external-link>
      </template>
      <template v-else>
        {{ channelFacility.ID }}
      </template>
    </td>
    <td>{{ channelFacility.externalFacilityID }}</td>
    <td>
      <v-checkbox
        v-model="channelFacilityIds"
        multiple
        :value="channelFacility.ID"
        :readonly="readonly"
        hide-details
      />
    </td>
    <td>
      <v-checkbox
        v-model="dontSendRatesForChannelFacilityIds"
        multiple
        :value="channelFacility.ID"
        :readonly="readonly"
        :disabled="!channelFacilityIds.includes(channelFacility.ID)"
        hide-details
      />
    </td>
    <td>
      <template v-if="channelFacility.channel === 'spothero'">

        <v-btn @click="openDiscountModal()" variant="outlined">

          <template v-if="!spotheroFlexDiscounts.length">
            Set Discounts
          </template>

          <template v-else>
            <div class="d-flex text-center ga-3">
              <div>
                {{ spotheroFlexDiscounts.length }}<br>
                Active
              </div>
              <div class="bg-dark">
                Mday<br>
                {{ spotheroFlexDiscounts.filter(sfd => sfd.discountType === 'multi_day').length }}
              </div>
              <div class="bg-dark">
                Early<br>
                {{ spotheroFlexDiscounts.filter(sfd => sfd.discountType === 'early_booking').length }}
              </div>
            </div>
          </template>

        </v-btn>

      </template>
      <template v-else>
        <span class="text-grey">—</span>
      </template>
    </td>
  </tr>

</template>

<script setup lang="ts">

import { computed } from 'vue'
import SpotHeroFlexDiscountsModal from './SpotHeroFlexDiscountsModal.vue'
import ExternalLink from '../../../ExternalLink.vue'
import { ChannelFacility } from '../../../../models/ChannelFacility'
import SpotHeroFlexDiscount from '../../../../models/SpotHeroFlexDiscount'
// @ts-ignore
import { openDialog } from 'vue3-promise-dialog'
import ChannelRegistry from '../../../../channels/ChannelRegistry'
import PermissionsService from '../../../../services/PermissionsService'

const canSeeIds = PermissionsService.can('seeids')
const canViewDashboard = PermissionsService.can('dashboard.view')
import DashboardRouter from '../../../../services/DashboardRouter'

interface Props {
  locationId: number
  locationProductId: number
  channelFacility: ChannelFacility
  readonly?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  readonly: true,
})

const spotheroFlexDiscounts = computed(() => {
  return SpotHeroFlexDiscount.query().where('locationProductID', props.locationProductId).where('channelFacilityID', props.channelFacility.ID).get()
})

const channelFacilityIds = defineModel<number[]>('channelFacilityIds', {required: true})
const dontSendRatesForChannelFacilityIds = defineModel<number[]>('dontSendRatesForChannelFacilityIds', {required: true})

function openDiscountModal() {
    openDialog(SpotHeroFlexDiscountsModal, {
      locationId: props.locationId,
      locationProductId: props.locationProductId,
      channelFacility: props.channelFacility,
      spotheroFlexDiscounts: spotheroFlexDiscounts.value,
    })
}

</script>
